const VIDEO_TYPES = {
  mp4: 'video/mp4',
  mov: 'video/quicktime',
};

const toMicroseconds = (seconds) => Math.round(Number(seconds) * 1_000_000);

export const getJianyingVideoContentType = (file = {}) => {
  const extension = String(file.name || '')
    .split('.')
    .pop()
    ?.toLowerCase();
  const expected = VIDEO_TYPES[extension];
  const supplied = String(file.type || '').toLowerCase();
  if (!expected || (supplied && supplied !== expected)) {
    throw new Error('视频只支持 MP4 或 MOV 文件');
  }
  return supplied || expected;
};

export const normalizeJianyingVideoSelection = ({
  fileDurationSeconds,
  startSeconds,
  endSeconds,
  targetDurationUs,
} = {}) => {
  const fileDurationUs = toMicroseconds(fileDurationSeconds);
  const sourceStartUs = toMicroseconds(startSeconds);
  const sourceEndUs = toMicroseconds(endSeconds);
  const normalizedTargetDurationUs = Number(targetDurationUs);
  const sourceDurationUs = sourceEndUs - sourceStartUs;
  if (
    !Number.isSafeInteger(fileDurationUs)
    || fileDurationUs <= 0
    || !Number.isSafeInteger(sourceStartUs)
    || sourceStartUs < 0
    || !Number.isSafeInteger(sourceEndUs)
    || sourceDurationUs <= 0
    || sourceEndUs > fileDurationUs
    || !Number.isSafeInteger(normalizedTargetDurationUs)
    || normalizedTargetDurationUs <= 0
  ) {
    throw new Error('视频选择范围无效');
  }
  return {
    file_duration_us: fileDurationUs,
    source_start_us: sourceStartUs,
    source_duration_us: sourceDurationUs,
    speed: sourceDurationUs / normalizedTargetDurationUs,
  };
};
